const actions = {
  POST_PROCESS_DOCUMET_BEGIN: 'POST_PROCESS_DOCUMET_BEGIN',
  POST_PROCESS_DOCUMET_SUCCESS: 'POST_PROCESS_DOCUMET_SUCCESS',
  POST_PROCESS_DOCUMET_ERROR: 'POST_PROCESS_DOCUMET_ERROR',

  GET_DOCUMENT_BY_ID_BEGIN: 'GET_DOCUMENT_BY_ID_BEGIN',
  GET_DOCUMENT_BY_ID_SUCCESS: 'GET_DOCUMENT_BY_ID_SUCCESS',
  GET_DOCUMENT_BY_ID_ERROR: 'GET_DOCUMENT_BY_ID_ERROR',

  GET_LOG_BY_DOCUMENT_ID_BEGIN: 'GET_LOG_BY_DOCUMENT_ID_BEGIN',
  GET_LOG_BY_DOCUMENT_ID_SUCCESS: 'GET_LOG_BY_DOCUMENT_ID_SUCCESS',
  GET_LOG_BY_DOCUMENT_ID_ERROR: 'GET_LOG_BY_DOCUMENT_ID_ERROR',

  GET_PDF_BY_DOCUMENT_ID_BEGIN: 'GET_PDF_BY_DOCUMENT_ID_BEGIN',
  GET_PDF_BY_DOCUMENT_ID_SUCCESS: 'GET_PDF_BY_DOCUMENT_ID_SUCCESS',
  GET_PDF_BY_DOCUMENT_ID_ERROR: 'GET_PDF_BY_DOCUMENT_ID_ERROR',

  POST_REVALIDATE_DOCUMENT_BEGIN: 'POST_REVALIDATE_DOCUMENT_BEGIN',
  POST_REVALIDATE_DOCUMENT_SUCCESS: 'POST_REVALIDATE_DOCUMENT_SUCCESS',
  POST_REVALIDATE_DOCUMENT_ERROR: 'POST_REVALIDATE_DOCUMENT_ERROR',

  PATCH_REVALIDATED_DOCUMENT_CHANGE_IS_LOCKED_BEGIN:
    'PATCH_REVALIDATED_DOCUMENT_CHANGE_IS_LOCKED_BEGIN',
  PATCH_REVALIDATED_DOCUMENT_CHANGE_IS_LOCKED_SUCCESS:
    'PATCH_REVALIDATED_DOCUMENT_CHANGE_IS_LOCKED_SUCCESS',
  PATCH_REVALIDATED_DOCUMENT_CHANGE_IS_LOCKED_ERROR:
    'PATCH_REVALIDATED_DOCUMENT_CHANGE_IS_LOCKED_ERROR',

  GET_ALLOWED_DOCUMENT_TYPES_BEGIN: 'GET_ALLOWED_DOCUMENT_TYPES_BEGIN',
  GET_ALLOWED_DOCUMENT_TYPES_SUCCESS: 'GET_ALLOWED_DOCUMENT_TYPES_SUCCESS',
  GET_ALLOWED_DOCUMENT_TYPES_ERROR: 'GET_ALLOWED_DOCUMENT_TYPES_ERROR',

  GET_DOCUMENT_ORDERS_BEGIN: 'GET_DOCUMENT_ORDERS_BEGIN',
  GET_DOCUMENT_ORDERS_SUCCESS: 'GET_DOCUMENT_ORDERS_SUCCESS',
  GET_DOCUMENT_ORDERS_ERROR: 'GET_DOCUMENT_ORDERS_ERROR',

  GET_DOCUMENT_ORDERS_BY_IDS_BEGIN: 'GET_DOCUMENT_ORDERS_BY_IDS_BEGIN',
  GET_DOCUMENT_ORDERS_BY_IDS_SUCCESS: 'GET_DOCUMENT_ORDERS_BY_IDS_SUCCESS',
  GET_DOCUMENT_ORDERS_BY_IDS_ERROR: 'GET_DOCUMENT_ORDERS_BY_IDS_ERROR',

  POST_UPDATE_ORDERS_BEGIN: 'POST_UPDATE_ORDERS_BEGIN',
  POST_UPDATE_ORDERS_SUCCESS: 'POST_UPDATE_ORDERS_SUCCESS',
  POST_UPDATE_ORDERS_ERROR: 'POST_UPDATE_ORDERS_ERROR',

  postProcessDocumentBegin: () => {
    return {
      type: actions.POST_PROCESS_DOCUMET_BEGIN,
    };
  },
  postProcessDocumentSuccess: data => {
    return {
      type: actions.POST_PROCESS_DOCUMET_SUCCESS,
      data,
    };
  },
  postProcessDocumentError: err => {
    return {
      type: actions.POST_PROCESS_DOCUMET_ERROR,
      err,
    };
  },

  getDocumentByIdBegin: () => {
    return {
      type: actions.GET_DOCUMENT_BY_ID_BEGIN,
    };
  },
  getDocumentByIdSuccess: data => {
    return {
      type: actions.GET_DOCUMENT_BY_ID_SUCCESS,
      data,
    };
  },
  getDocumentByIdError: err => {
    return {
      type: actions.GET_DOCUMENT_BY_ID_ERROR,
      err,
    };
  },

  getLogByDocumentIdBegin: () => {
    return {
      type: actions.GET_LOG_BY_DOCUMENT_ID_BEGIN,
    };
  },
  getLogByDocumentIdSuccess: data => {
    return {
      type: actions.GET_LOG_BY_DOCUMENT_ID_SUCCESS,
      data,
    };
  },
  getLogByDocumentIdError: err => {
    return {
      type: actions.GET_LOG_BY_DOCUMENT_ID_ERROR,
      err,
    };
  },

  getPdfByDocumentIdBegin: () => {
    return {
      type: actions.GET_PDF_BY_DOCUMENT_ID_BEGIN,
    };
  },
  getPdfByDocumentIdSuccess: data => {
    return {
      type: actions.GET_PDF_BY_DOCUMENT_ID_SUCCESS,
      data,
    };
  },
  getPdfByDocumentIdError: err => {
    return {
      type: actions.GET_PDF_BY_DOCUMENT_ID_ERROR,
      err,
    };
  },

  postRevalidateDocumentBegin: () => {
    return {
      type: actions.POST_REVALIDATE_DOCUMENT_BEGIN,
    };
  },
  postRevalidateDocumentSuccess: data => {
    return {
      type: actions.POST_REVALIDATE_DOCUMENT_SUCCESS,
      data,
    };
  },
  postRevalidateDocumentError: err => {
    return {
      type: actions.POST_REVALIDATE_DOCUMENT_ERROR,
      err,
    };
  },

  patchRevalidatedDocumentChangeIsLockedBegin: () => {
    return {
      type: actions.PATCH_REVALIDATED_DOCUMENT_CHANGE_IS_LOCKED_BEGIN,
    };
  },
  patchRevalidatedDocumentChangeIsLockedSuccess: data => {
    return {
      type: actions.PATCH_REVALIDATED_DOCUMENT_CHANGE_IS_LOCKED_SUCCESS,
      data,
    };
  },
  patchRevalidatedDocumentChangeIsLockedError: err => {
    return {
      type: actions.PATCH_REVALIDATED_DOCUMENT_CHANGE_IS_LOCKED_ERROR,
      err,
    };
  },

  getAllowedDocumentTypesBegin: () => {
    return {
      type: actions.GET_ALLOWED_DOCUMENT_TYPES_BEGIN,
    };
  },
  getAllowedDocumentTypesSuccess: data => {
    return {
      type: actions.GET_ALLOWED_DOCUMENT_TYPES_SUCCESS,
      data,
    };
  },
  getAllowedDocumentTypesError: err => {
    return {
      type: actions.GET_ALLOWED_DOCUMENT_TYPES_ERROR,
      err,
    };
  },

  getDocumentOrdersBegin: () => {
    return {
      type: actions.GET_DOCUMENT_ORDERS_BEGIN,
    };
  },
  getDocumentOrdersSuccess: data => {
    return {
      type: actions.GET_DOCUMENT_ORDERS_SUCCESS,
      data,
    };
  },
  getDocumentOrdersError: err => {
    return {
      type: actions.GET_DOCUMENT_ORDERS_ERROR,
      err,
    };
  },

  getDocumentOrdersByIdsBegin: () => {
    return {
      type: actions.GET_DOCUMENT_ORDERS_BY_IDS_BEGIN,
    };
  },
  getDocumentOrdersByIdsSuccess: data => {
    return {
      type: actions.GET_DOCUMENT_ORDERS_BY_IDS_SUCCESS,
      data,
    };
  },
  getDocumentOrdersByIdsError: err => {
    return {
      type: actions.GET_DOCUMENT_ORDERS_BY_IDS_ERROR,
      err,
    };
  },

  postUpdateOrdersBegin: () => {
    return {
      type: actions.POST_UPDATE_ORDERS_BEGIN,
    };
  },
  postUpdateOrdersSuccess: data => {
    return {
      type: actions.POST_UPDATE_ORDERS_SUCCESS,
      data,
    };
  },
  postUpdateOrdersError: err => {
    return {
      type: actions.POST_UPDATE_ORDERS_ERROR,
      err,
    };
  },
};

export default actions;
